<template>
  <Layout>
    <PageHeader :items="items" :title="title"/>

    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div v-if="Object.keys(ses).length !== 0" class="form-row" style="margin-top: -15px;margin-bottom: 10px;">
            <div class="col-md-6">
              <h5 class="float-left" style="color: #10948E">Name:  {{ ses.name }} - EP ID: {{ ses.ep_id.ep_id }}</h5>
            </div>
          </div>

          <form action="">
            <div>
              <table class="table table-centered table-striped">
                <thead>
                <tr>
                  <th></th>
                  <th>Sl</th>
                  <th>File Name</th>
                  <th>Date</th>
                  <th>Remarks</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(file_tracking, index) in file_trackings" :key="index">
                  <td>
                    <input type="checkbox" v-model="file_trackings[index].doc_sub_cat_id" :value="file_tracking.doc_sub_cat_id" :name="'file-tracking-' + index"  class="file-tracking"/>
                  </td>
                  <td>{{ index + 1 }}</td>
                  <td>
                    <span class="checkbox-label"> {{ file_tracking.doc_sub_cat_desc }}</span>
                  </td>
                  <td>
                    <datepicker v-model="file_trackings[index].upload_date"  :name="'uploaded-date-' + index"  :format="customUploadDate" placeholder="Upload Date"></datepicker>
                  </td>
                  <td>
                    <input type="text" v-model="file_trackings[index].remarks" :name="'remarks-' + index" class="form-control form-control-sm" placeholder="Remarks"/>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <button class="btn btn-success waves-effect waves-light mr-2" @click.prevent="save">Save</button>
          </form>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  page: {
    title: "File Tracking Create",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader, Datepicker},
  data() {
    return {
      title: "File Tracking Create",
      items: [
        {
          text: "EP",
          href: "ep/files"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      ses_id: "",
      is_file_tracking_checked: "",
      ses: {},
      file_trackings: [],
      validation_errors: {},
      show: false
    };
  },
  mounted() {
    this.ses_id = this.$route.params.ses_id;
    this.getFileTracking();
  },
  methods: {
    customUploadDate(date) {
      this.file_trackings.upload_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    getFileTracking() {
      let ses_id = this.$route.params.ses_id;
      http
          .get("api/ep/file-tracking/" + ses_id)
          .then(response => {
            this.ses = response.data.ses;
            this.file_trackings = response.data.file_trackings;
          })
          .catch();
    },
    save() {
      http
          .post("api/ep/file-tracking/store", {
            ses_id: this.ses_id,
            file_trackings: this.file_trackings
          })
          .then(response => {
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
              variant: "success"
            });

            this.$router.push("/ep/file-tracking/list");
          })
          .catch();
    },
  },


};
</script>
<style>
.file-tracking{
   margin-bottom: 8px;
}
.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
  z-index:1001 !important;
}
</style>
